import { render, staticRenderFns } from "./BusinessConfig.vue?vue&type=template&id=58f9e903&scoped=true"
import script from "./BusinessConfig.vue?vue&type=script&lang=js"
export * from "./BusinessConfig.vue?vue&type=script&lang=js"
import style0 from "./BusinessConfig.vue?vue&type=style&index=0&id=58f9e903&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9e903",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f9e903')) {
      api.createRecord('58f9e903', component.options)
    } else {
      api.reload('58f9e903', component.options)
    }
    module.hot.accept("./BusinessConfig.vue?vue&type=template&id=58f9e903&scoped=true", function () {
      api.rerender('58f9e903', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/BusinessConfig.vue"
export default component.exports